import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
const mainCitiesInJordan = [
    'Amman', 'Aqaba', 'Zarqa', 'Irbid', 'Mafraq', 'Madaba', 'Karak', 'Salt', 'Tafilah'
];
export default function Booking() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const [selectedService, setSelectedService] = useState('');
    const [selectedCity, setSelectedCity] = useState('');

    const handleServiceChange = (e) => {
        setSelectedService(e.target.value);
    };

    const handleCityChange = (e) => {
        setSelectedCity(e.target.value);
    };

    return (
        <>
            <section className="landingPages">
                <div className="container h-[70vh] flex flex-col justify-center gap-[10px]">
                    <div className="btmAni2000 text-[40px] font-bold text-white  capitalize">{t("Booking session")}</div>
                    <div className="btmAni25002 flex items-center gap-[5px] text-white">
                        <Link className="text-white" to={"/"}>{t("Home")}</Link>
                        -
                        <div className="text-[#016E82]">{t("Booking session")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col justify-center gap-[20px]">
                    <div className="btmAni20002 text-[35px] text-center text-white font-bold">{t("Book Your Aqaba Season Experience")}</div>
                    <form action={"https://aqaba-seasons.com/submitForm.php"} method="POST">
                        <div className="flex flex-col gap-[12px]">
                            <div className="f-col flex items-center gap-[12px]">
                                <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                    <label className="text-white font-bold js-scroll fade-top">{t("Full Name")}</label>
                                    <input
                                        className="js-scroll fade-btm w-100 w-full p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                        type="text"
                                        placeholder={t("Enter Your Name")}
                                        required
                                        name="fullName"
                                    />
                                </div>
                                <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                    <label className="text-white font-bold js-scroll fade-top">{t("Email")}</label>
                                    <input
                                        className="js-scroll fade-btm w-100 w-full p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                        type="email"
                                        placeholder={t("Enter Your Email")}
                                        required
                                        name="email"
                                    />
                                </div>
                            </div>
                            <div className="f-col flex items-center gap-[12px]">
                                <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                    <label className="text-white font-bold js-scroll fade-top">{t("The Service")}</label>
                                    <select
                                        className="js-scroll fade-btm w-100 w-full p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-[#8a909a]"
                                        value={selectedService}
                                        onChange={handleServiceChange}
                                        required
                                        name="service"
                                    >
                                        <option value="" disabled>{t("Select Your Service")}</option>
                                        <option value="Fashions">{t("Fashions")}</option>
                                        <option value="Events">{t("Events")}</option>
                                        <option value="Graduation">{t("Graduation")}</option>
                                    </select>
                                </div>
                                <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                    <label className="text-white font-bold js-scroll fade-top">{t("Phone")}</label>
                                    <input
                                        className="js-scroll fade-btm w-100 w-full p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                        type="number"
                                        placeholder={t("Enter Your Phone")}
                                        required
                                        name="phone"
                                    />
                                </div>
                            </div>
                            <div className="w-100 w-[48%] flex flex-col gap-[7px]">
                                <label className="text-white font-bold js-scroll fade-top">{t("Location")}</label>
                                <select
                                    className="js-scroll fade-btm w-100 w-full p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-[#8a909a]"
                                    value={selectedCity}
                                    onChange={handleCityChange}
                                    required
                                    name="location"
                                >
                                    <option value="" disabled>{t("Select Your City")}</option>
                                    {mainCitiesInJordan.map((city, index) => (
                                        <option key={index} value={city}>
                                            {city}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <button className="js-scroll fade-btm w-fit bg-[#016E82] text-white px-[20px] py-[8px] rounded font-bold capitalize">{t("Booking Now")}</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}